export default __webpack_public_path__ + "static/media/922.68f013d8.png";